module.exports = __webpack_public_path__ + "img/yw1.23e02bfc.jpg";